import { useLocation } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';

import Typography from '~/shared/components/Typography';
import Tag from '~/shared/components/Tag';

import { SectionFooter } from './SectionFooter';
import { RoleArnRow } from './RoleArnRow';
import { useAuthContext } from '~/shared/context/useAuthContext';
import { useOrganizationStatus } from '~/shared/utils/organizationUtils';
import Loader from '~/shared/components/Loader';

export function RoleArn() {
  const { accounts, activeTenantId, activeTenantName } = useAuthContext();
  const { isOrganizationAccount } = useOrganizationStatus(accounts, activeTenantId);
  const search = useLocation().search;
  const showDevTools = !!new URLSearchParams(search).get('devtools');

  if (!activeTenantId) {
    return (
      <div className="flex items-center justify-center w-full h-full">
        <Loader variant="xl" />
      </div>
    );
  }

  return (
    <div className="px-3.5">
      <div className="flex flex-col gap-2 py-7.5">
        <Typography variant="H4-med" fontWeight={500} className="text-primary-900">
          Role ARN
          Role ARN
        </Typography>
        <div className="flex items-center gap-2">
          {activeTenantName ? (
            <Tag
              text={activeTenantName || ''}
              variant="default"
              className="text-gray-700!"
            />
          ) : (
            <Skeleton
              containerClassName=" block leading-[unset!important]"
              className="h-[28px] leading-[unset!important] rounded-[8px] "
              baseColor="var(--color-gray-200)"
              highlightColor="#FFFF"
              width={80}
            />
          )}
          <Typography variant="p3" fontWeight={400} color="text-gray-700">
            ID: {activeTenantId}
          </Typography>
        </div>
      </div>

      <RoleArnRow
        accountId={activeTenantId}
        accountName={activeTenantName ?? undefined}
        isOrganization={isOrganizationAccount ?? false}
        variant="SingleAccountView"
        showDevTools={showDevTools}
        renderFooter={({
          isLoading,
          isRoleArnLoading,
          isSubmitting,
          isUpdatePending,
          forceEditable,
          roleArn,
          footerErrorId,
          hasRootError,
        }) => (
          <SectionFooter
            infoProps={
              isLoading || isRoleArnLoading || isSubmitting || isUpdatePending
                ? {
                  variant: 'none',
                  text: (
                    <div className="h-6 py-1 flex items-center">
                      <Skeleton
                        containerClassName=" block leading-[unset!important]"
                        className="h-3 leading-[unset!important] rounded-lg "
                        baseColor="var(--color-gray-200)"
                        highlightColor="#FFFF"
                        width={200}
                      />
                    </div>
                  ),
                }
                : hasRootError
                  ? {
                    text: <span id={footerErrorId}>Input is invalid</span>,
                    variant: 'error',
                  }
                  : forceEditable || roleArn
                    ? {
                      text: (
                        <span>Input the ARN of the IAM role that provides Datafy permissions </span>
                      ),
                      variant: 'success',
                    }
                    : { text: 'Input the ARN of the IAM role that provides Datafy permissions' }
            }
          />
        )}
      />
    </div>
  );
}
